import {parseISO} from "date-fns";

/*
 * A full version of a BookingItem object
 */
export default class BookingItem {

    constructor(apiResponse) {
        this.id = apiResponse.id;
        this.bookableType = apiResponse.bookableType;
        this.bookableId = apiResponse.bookableId;
        this.arrival = parseISO(apiResponse.arrival + "T13");
        this.departure = parseISO(apiResponse.departure + "T11");
        this.price = apiResponse.price ? Number.parseFloat(apiResponse.price) : null;
    }

    clone() {
        const bookingItem = new BookingItem({});
        bookingItem.id = this.id;
        bookingItem.bookableType = this.bookableType;
        bookingItem.bookableId = this.bookableId;
        bookingItem.arrival = this.arrival ? new Date(this.arrival) : null;
        bookingItem.departure = this.departure ? new Date(this.departure) : null;
        bookingItem.price = this.price;
        return bookingItem;
    }

    // Alias property used by planner
    get startDate() {
        return this.arrival;
    }

    // Alias property used by planner
    get endDate() {
        return this.departure;
    }
}